import React from 'react';
import {User} from "fearless-common";
import {getFullName, Loading} from "fearless-common-ui";
import useGet from "../../components/hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";
import {Pages} from "../../components/layout";
import useTitle from "../../components/hooks/useTitle";
import Alert from "react-bootstrap/Alert";

type CounterHashMap = Record<string, number>
/**
 * Show a nice table of the hashmap
 * @param hashMap E.g. {alpha => 1, beta: 2, ...}
 */
function Counted({ hashMap }: { hashMap: CounterHashMap}) {
    return (
        <table>
            <tbody>
            {Object.keys(hashMap).map((k) => (
                <tr key={k}>
                    <td><label>{k || <i>No value</i>}:&nbsp;&nbsp;</label></td>
                    <td>{hashMap[k]}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

const UserSpan = (u: User) => <div key={u.id}>{getFullName(u)}</div>;

interface Insights {
  joined_since_14_days_ago: User[];
  users_with_new_subscriptions: User[];
  versions_used: CounterHashMap;
  email_domains: CounterHashMap;
  last_used_desktop_OS_per_user: CounterHashMap;
}

export default function AdminInsights() {
    const { data: stats, isLoading, error } = useGet<Insights>({
        endpoint: backendEndpoints.getAdminUserStats,
    });
    useTitle(`Admin Insights`);
    return (
        <Pages.Centred>
            <h1>User statistics</h1>
          {error && <Alert />}
          {isLoading && <Loading />}
          {stats && (
            <>
              <h3>Users to encourage</h3>
              <table className="table table-bordered text-sm table-sm">
                <thead>
                <tr>
                  <th>Joined since 2 weeks ago</th>
                  <th>New subscription since 4 weeks ago</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    {stats.joined_since_14_days_ago.length > 0 ? stats.joined_since_14_days_ago.map(UserSpan) : <i>No new users</i>}
                  </td>
                  <td>
                    {stats.users_with_new_subscriptions.length > 0 ? stats.users_with_new_subscriptions.map(UserSpan) : <i>No new subscriptions</i>}
                  </td>
                </tr>
                </tbody>
              </table>
              <h3>General user statistics</h3>
              <table className="table table-bordered text-sm table-sm">
                <tbody>
                {['versions_used', 'email_domains', 'last_used_desktop_OS_per_user'].map((key) => (
                  <tr key={key}>
                    <td valign="top" width={200}>{key}</td>
                    <td>
                      {key in stats // @ts-ignore
                        ? <Counted hashMap={stats[key]}/> : stats[key]}
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </>
          )}
        </Pages.Centred>
    );
}
